// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__lyI-I","selects":"Documents_selects__3ZGTE"};